import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { PrakurtiLogoWhite } from '../../components/imagepath';
import { Formik } from 'formik';
import { LoginValidationSchema } from '../../utils/FormValidation';
import { ActionLoginUser } from '../../store/Actions/AuthActions';
import { InputFromUser } from '../../components/Input/input';
import { SubmitButton } from '../../components/Button';

const Login = () => {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <div className="col-lg-6 login-wrap">
              <div className="login-sec">
              </div>
            </div>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="account-logo" style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <Link to="/admin-dashboard">
                          <img
                            src={PrakurtiLogoWhite}
                            alt="Prakruti Logo"
                            style={{ maxWidth: '180px', height: 'auto' }}
                          />
                        </Link>
                      </div>
                      <h2 style={{ textAlign: 'center', marginBottom: '10px' }}>Admin Panel</h2>
                      <p style={{ textAlign: 'center', color: '#6c757d', marginBottom: '25px' }}>
                        Sign in to access your dashboard
                      </p>
                      <Formik
                        initialValues={{ email: '', password: '' }}
                        validationSchema={LoginValidationSchema}
                        onSubmit={(values, { setErrors, setSubmitting }) => {
                          dispatch(
                            ActionLoginUser(values, response => {
                              if (response?.statusCode == 400) {
                                setErrors(response?.data?.errors);
                                setSubmitting(false);
                              } else if (response?.statusCode == 401) {
                                setErrors(response?.data?.errors);
                                setSubmitting(false);
                              } else if (response?.data?.statusCode == 200 || response?.status == 200) {
                                window.location.href = '/admin-dashboard';
                              } else {
                                setSubmitting(false);
                              }
                            })
                          );
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                        }) => {
                          return (
                            <form onSubmit={handleSubmit}>
                              <InputFromUser
                                label="Email"
                                name="email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.email}
                                value={values.email}
                                touched={touched.email}
                                placeholder={'Enter Your Email'}
                              />
                              <InputFromUser
                                label="Password"
                                type="password"
                                name="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                error={errors.password}
                                touched={touched.password}
                                placeholder={'Enter Your Password'}
                              />

                              <div className="forgotpass">
                                <Link to="/forgot-password">Forgot Password?</Link>
                              </div>
                              <div className="form-group login-btn">
                                <SubmitButton
                                  htmlType="submit"
                                  className="btn btn-primary btn-block"
                                  loading={isSubmitting}
                                >
                                  Sign In
                                </SubmitButton>
                              </div>
                            </form>
                          );
                        }}
                      </Formik>

                      {/* Security Notice */}
                      <div style={{
                        marginTop: '25px',
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        borderLeft: '3px solid #0d6efd'
                      }}>
                        <p style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          margin: 0,
                          lineHeight: '1.5'
                        }}>
                          <strong>🔒 Secure Access:</strong> This area is restricted to authorized administrators only. All login attempts are monitored and logged for security purposes.
                        </p>
                      </div>

                      {/* Footer */}
                      <div style={{
                        marginTop: '20px',
                        textAlign: 'center',
                        paddingTop: '15px',
                        borderTop: '1px solid #e9ecef'
                      }}>
                        <p style={{ fontSize: '12px', color: '#6c757d', margin: '5px 0' }}>
                          © {currentYear} Prakruti. All Rights Reserved.
                        </p>
                        <p style={{ fontSize: '11px', color: '#adb5bd', margin: '5px 0' }}>
                          Need help? Contact feelbetter@prakruti.health
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
